import { NgModule } from '@angular/core';
import { ModalSuccessTransferenceComponent } from './modal-success-transference.component';

@NgModule({
  imports: [ModalSuccessTransferenceComponent],
  exports: [ModalSuccessTransferenceComponent],
})
export class TransferenceResultModalModule {}
